// Module
var code = "<p>{{'variable_suppressSingleEvent_suppressConfirmationUnknown' | translate:{ eventName: eventDetailsName } }}</p> ";
// Exports
var _module_exports =code;;
var path = '/views/attacks/suppress_event_single_unknown.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;